import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { TEAM_LIST } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';

@Component({
  selector: 'app-delete-team',
  standalone: false,
  templateUrl: './delete-team.component.html',
  styleUrl: './delete-team.component.scss'
})
export class DeleteTeamComponent {
    $destroy = new Subject
    @Input() isShowConfirm: boolean = false;
    @Input() idTeam: number = 0;
    @Output() isShowConfirmEvent = new EventEmitter<boolean>();
  
    constructor(
      private router: Router,
      private baseService: BaseService,
      private message: NzMessageService
    ) {}
  
    handleCancel() {
      this.isShowConfirm = false
      this.isShowConfirmEvent.emit()
    }
  
  handleContinue() {
    this.baseService.deleteData(TEAM_LIST + `/${this.idTeam}`)
      .pipe(takeUntil(this.$destroy))
      .subscribe((res) => {
        this.message.success("Team's deleted successfully")
        this.isShowConfirm = false
        this.isShowConfirmEvent.emit()
      }, (err) => {
        this.message.error("Failed to deleted team's")
    })
    }
}
